/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */

let instance: OGImage;
export default class OGImage {
  private _currentImage = '';

  private _currentUrl = '';

  public static getInstance() {
    if (!instance) {
      instance = new OGImage();
    }
    return instance;
  }

  public get currentImage() {
    return this._currentImage;
  }

  public set currentImage(val: string) {
    this._currentImage = val;
  }

  public get currentUrl() {
    return this._currentUrl;
  }

  public set currentUrl(val: string) {
    this._currentUrl = val;
  }
}
